/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ClusterStates } from '../../server';
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
});

export const GetAllCluster = {
  id: 'cluster-all.get',
  tag: 'Cluster',
  summary: 'Get all clusters',
  description: 'Retrieve all clusters within an organization project',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              id: ZodTypes.Id,
              type: ZodTypes.ServiceType,
              name: z.string().min(1),
              description: z.string().min(1).nullable().optional(),
              createdAt: z.date(),
              updatedAt: z.date(),
              configuration: z
                .array(
                  z.strictObject({
                    id: ZodTypes.Id,
                    createdAt: z.date(),
                    replicas: z.number().min(0),
                    endedAt: z.date().or(z.literal('infinity')),
                    cpuUnits: z.number().min(0),
                    memoryGbs: z.number().min(0),
                    storageGbs: z.number().min(0),
                    postgresVersion: z.number().min(0),
                    storageClassId: z.string().min(1),
                    supportPlan: z.strictObject({
                      id: ZodTypes.Id,
                      name: z.string().min(1),
                      description: z.string().min(1),
                      isDefault: z.boolean(),
                      price: z.number(),
                    }),
                    storageClass: z.strictObject({
                      id: z.string().min(1),
                      isDefault: z.boolean(),
                    }),
                  }),
                )
                .optional(),
              isCloning: z.boolean().optional(),
              namespace: z.string().optional(),
              sequenceId: z.string(),
              status: z.nativeEnum(ClusterStates).optional(),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
